import { render, staticRenderFns } from "./EnhancedAdminDashboard.vue?vue&type=template&id=56e706a0&scoped=true"
import script from "./EnhancedAdminDashboard.vue?vue&type=script&lang=js"
export * from "./EnhancedAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./EnhancedAdminDashboard.vue?vue&type=style&index=0&id=56e706a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e706a0",
  null
  
)

export default component.exports